import { CircleHelp } from '../icons';
import { useTheme } from '../../hooks/useTheme';
import { Tooltip } from '../Tooltip';
import { CommodityConditionProps } from './CommodityCondition.types';

const BaseIcon = ({ className }: { className?: string }) => (
  <svg
    role="img"
    aria-label="Inoperable Icon"
    className={['flex items-center justify-center', className].join(' ')}
    data-testid="base-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 67.1 61.71"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          className="fill-[#bfbfbf]"
          d="M64.54,23.21H60.91L56.14,2a2.56,2.56,0,0,0-2.5-2H13.34a2.56,2.56,0,0,0-2.5,2L6.19,23.21H2.56A2.56,2.56,0,0,0,0,25.77V50.29a2.57,2.57,0,0,0,2.56,2.57H3.92v5.6a3.26,3.26,0,0,0,3.25,3.25h10.1a3.26,3.26,0,0,0,3.25-3.25v-5.6H46.59v5.6a3.25,3.25,0,0,0,3.25,3.25H59.93a3.26,3.26,0,0,0,3.25-3.25v-5.6h1.36a2.56,2.56,0,0,0,2.56-2.57V25.77A2.56,2.56,0,0,0,64.54,23.21ZM15.4,5.13H51.58l4.08,18.08H11.44Z"
        />
        <rect
          className="fill-common-white"
          x="8.73"
          y="32.72"
          width="9.19"
          height="9.19"
          rx="4.6"
        />
        <rect
          className="fill-common-white"
          x="49.18"
          y="32.72"
          width="9.19"
          height="9.19"
          rx="4.6"
        />
      </g>
    </g>
  </svg>
);

export const CommodityCondition = ({ operable }: CommodityConditionProps) => {
  const theme = useTheme();

  if (operable) return null;

  if (operable === null) {
    return (
      <Tooltip title="Not Verified">
        <CircleHelp
          role="img"
          aria-label="Not Verified Icon"
          data-testid="base-icon"
          color={theme.palette.warning.main}
          size="1.2rem"
          className="max-h-4 max-w-4 cursor-pointer"
        >
          <title>Not Verified</title>
        </CircleHelp>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Inoperable">
      <BaseIcon
        css={{
          width: theme.iconSizes.sm,
          height: theme.iconSizes.sm,
          path: {
            fill: theme.palette.error.main,
          },
        }}
      />
    </Tooltip>
  );
};
